import { createUserInfoSource } from '@forest/paywall-core'
import { native, pageVisibleOnce } from '@forest/native-services'
import { atom } from 'nanostores'
import type { ServiceLevelStatus, UserInfo } from './types'

export const $isSubscribeButtonReady = atom(false)

export const userInfoSource = createUserInfoSource({
  load: async () => {
    if (import.meta.env.DEV) {
      return {
        user_id: 0,
        token: '123',
        server: 'staging',
        user_type: 'seekr_id',
      } satisfies UserInfo
    }
    await pageVisibleOnce.promise
    const result = await native.user.getUserInfo()
    if (!result.success || !result.data) {
      throw new Error('Failed to get user info')
    }
    return result.data
  },
  refresh: async () => {
    const result = await native.user.refreshToken()
    if (!result.success) throw new Error('Failed to refresh token')
    return result.data
  },
})

export const $userInfo = userInfoSource.atom

export const $serviceLevelStatus = atom<ServiceLevelStatus | null>(null)

export const $chinaAndroidTrialEligibility = atom<
  'pending' | 'available' | 'unavailable'
>('pending')

export const $isTrialEligible = atom<boolean>(false)

export const $isReminderViewOpen = atom(false)

export const $receiptSystemAccountId = atom<string | null>(null)

const params = new URLSearchParams(window.location.search)

export const $debugAfterPaymentError = atom(
  params.has('debug_after_payment_error'),
)

/** DEV-only: make the next purchase throw `interrupted` (abandoned checkout). */
export const $debugSimulateInterrupted = atom(params.has('debug_interrupted'))
